<template>
  <div v-if="loaded">
    <div class="card" v-for="(settings, system) in settings" :key="system">
      <div class="card-header">
        <h4>{{ system }}</h4>
      </div>
      <div class="card-body">
        <div
          class="row row-hover"
          v-for="(value, setting) in settings"
          :key="setting"
        >
          <div class="col-6">{{ setting }}</div>
          <div class="col-6">{{ value }}</div>
        </div>
      </div>
      <div class="card-footer"></div>
    </div>
  </div>
  <i class="fas fa-sync fa-7x fa-spin" v-else></i>
</template>

<script>
export default {
  data() {
    return {
      settings: {},
      loaded: false
    };
  },
  created() {
    this.$http
      .get("/api/v1/superadminDashboard/system-settings")
      .then(({ data }) => (this.settings = data))
      .finally(() => (this.loaded = true));
  }
};
</script>

<style>
.row-hover:hover {
  background-color: lightgray;
}
</style>
